module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDEyIDYiPjxwYXRoIGZpbGw9IiMwMDdhM2QiIGQ9Ik0wIDBoMTJ2MkgweiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDJoMTJ2MkgweiIvPjxwYXRoIGZpbGw9IiNjZTExMjYiIGQ9Ik0wIDRoMTJ2MkgweiIvPjxwYXRoIGQ9Ik0wIDBsMyAydjJMMCA2eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/kwt.svg
// module id = +w3q
// module chunks = 0